export default __webpack_public_path__ + "static/media/lamdarole.66e08567.png";